export default state => ({
  balanceAsyncCall: state.userBalance.aSyncCall,
  userBalance: state.userBalance.balance,
  userCoins: state.userBalance.coins,
});



// WEBPACK FOOTER //
// ./src/selectors/balanceSelector.js